export * from 'server/models/CargoActivity';


// WEBPACK FOOTER //
// ./data/models/CargoActivity.ts